"use strict";
/* eslint-disable no-underscore-dangle */
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModelOperation = exports.nameFor = void 0;
var ModelTypes_1 = require("./ModelTypes");
var ModelView_1 = require("./ModelView");
var $xnoop = 0;
var $xcreate = 10;
var $xdelete = 11;
var $xrestore = 12;
var $cset = 20;
var $cappend = 21;
var $ctruncate = 22;
// We have to do this verboseness because otherwise the types are "number" and not the "value" and it causes issues with typing
// elsewhere. ¯\_(ツ)_/¯
var codes = Object.freeze({
    $xnoop: $xnoop,
    $xcreate: $xcreate,
    $xdelete: $xdelete,
    $xrestore: $xrestore,
    $cset: $cset,
    $cappend: $cappend,
    $ctruncate: $ctruncate,
});
var nameFor = function (code) {
    switch (code) {
        case $xnoop: return '$xnoop';
        case $xcreate: return '$xcreate';
        case $xdelete: return '$xdelete';
        case $xrestore: return '$xrestore';
        case $cset: return '$cset';
        case $cappend: return '$cappend';
        case $ctruncate: return '$ctruncate';
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        default: throw new Error("".concat(code, " is not a moop code."));
    }
};
exports.nameFor = nameFor;
var $fail = -1;
var $skip = 0;
var $pass = 1;
var results = {
    $fail: $fail,
    $skip: $skip,
    $pass: $pass,
};
var execInternal = function (view, snapshot, moop) {
    var handler = exports.ModelOperation.getHandler(moop[0]);
    var _a = __read(handler.validate(view, moop), 2), result = _a[0], reason = _a[1];
    switch (result) {
        case $fail: throw new Error(reason);
        case $skip: return;
        case $pass: handler.perform(snapshot, moop);
    }
};
exports.ModelOperation = {
    /**
     * Definition of the codes of all the supported ModelOperation types.
     */
    codes: codes,
    /**
     * Definition of the results returned from ModelOperation.validate.
     */
    results: results,
    /**
     * Executes the specified ModelOperation against the specified ModelSnapshot.  _Execution_ means obtaining the appropriate
     * ModelOperationHandler and invoking the validate routine and then the perform routine.  Returns the entities affected.
     *
     * @param snapshot the snapshot to apply the execute against.
     * @param moop the operation.
     */
    exec: function (snapshot, moop) {
        execInternal(ModelView_1.ModelView.create(snapshot), snapshot, moop);
    },
    /**
     * Invokes _exec_ for each specified ModelOperation against the specified ModelSnapshot.  Throws an error if any of the operations fail.
     * Returns the entities affected.
     *
     * @param state the state to apply the execute against.
     * @param moops the operations.
     */
    execAll: function (snapshot, moops) {
        var e_1, _a;
        var view = ModelView_1.ModelView.create(snapshot);
        try {
            for (var moops_1 = __values(moops), moops_1_1 = moops_1.next(); !moops_1_1.done; moops_1_1 = moops_1.next()) {
                var m = moops_1_1.value;
                execInternal(view, snapshot, m);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (moops_1_1 && !moops_1_1.done && (_a = moops_1.return)) _a.call(moops_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
    },
    /**
     * Obtains the appropriate ModelOperationHandler for the specified ModelOperationCode.
     *
     * @param code the model operation code.
     */
    getHandler: function (code) {
        return handlers[code];
    },
    /**
     * See ModelOperationHandler.fingerprint
     *
     * @param moop
     */
    fingerprint: function (moop) {
        return exports.ModelOperation.getHandler(moop[0]).fingerprint(moop);
    },
    /**
     * See ModelOperationHandler.entities
     *
     * @param moop
     */
    entities: function (input) {
        if (Array.isArray(input[0])) {
            return (input)
                .flatMap(function (moop) { return handlers[moop[0]].entities(moop); });
        }
        else {
            var moop = input;
            return handlers[moop[0]].entities(moop);
        }
    },
};
var NoopHandler = {
    fingerprint: function (_moop) {
        return '';
    },
    entities: function (_moop) {
        return [];
    },
    validate: function (_model, _moop) {
        return pass();
    },
    reverse: function (_model, _moop) {
        return _moop;
    },
    stage: function (_buffer, _moop) {
        // eslint fo
    },
    perform: function (_root, _moop) {
        // eslint fo
    },
};
var CreateHandler = {
    fingerprint: function (moop) {
        return moop.slice(0, 2).join('/');
    },
    entities: function (moop) {
        return [moop[1]];
    },
    validate: function (model, _a) {
        var _b, _c, _d, _e;
        var _f = __read(_a, 4), code = _f[0], id = _f[1], variant = _f[2], type = _f[3];
        return ((_e = (_d = (_c = (_b = assertString(code, 'id', id)) !== null && _b !== void 0 ? _b : assertString(code, 'variant', variant)) !== null && _c !== void 0 ? _c : assertString(code, 'type', type)) !== null && _d !== void 0 ? _d : assertNotExists(model, code, id)) !== null && _e !== void 0 ? _e : pass());
    },
    reverse: function (_model, _a) {
        var _b = __read(_a, 4), _code = _b[0], id = _b[1], _variant = _b[2], _type = _b[3];
        return [$xdelete, id];
    },
    stage: function (buffer, moop) {
        return this.perform(buffer, moop);
    },
    perform: function (root, _a) {
        var _b = __read(_a, 4), _code = _b[0], id = _b[1], variant = _b[2], type = _b[3];
        var initialState = registerAlloc();
        if (variant === 'object' && type === 'list') {
            initialState.length = 0;
        }
        root.instances[id] = { variant: variant, type: type };
        root.states[id] = initialState;
        if (variant === 'component') {
            root.childLinks[id] = registerAlloc();
        }
    },
};
var DeleteHandler = {
    fingerprint: function (moop) {
        return moop.join('/');
    },
    entities: function (moop) {
        return [moop[1]];
    },
    validate: function (model, _a) {
        var _b, _c, _d, _e;
        var _f = __read(_a, 2), code = _f[0], id = _f[1];
        return ((_e = (_d = (_c = (_b = assertString(code, 'id', id)) !== null && _b !== void 0 ? _b : skipIfNot(assertExists(model, code, id))) !== null && _c !== void 0 ? _c : assertNoParent(model, code, id)) !== null && _d !== void 0 ? _d : assertNoChildren(model, code, id)) !== null && _e !== void 0 ? _e : pass());
    },
    reverse: function (model, _a) {
        var _b = __read(_a, 2), _code = _b[0], id = _b[1];
        var _c = model.getInfo(id), variant = _c.variant, type = _c.type;
        var state = model.getState(id);
        return [$xrestore, id, variant, type, state];
    },
    stage: function (buffer, _a) {
        var _b = __read(_a, 2), _code = _b[0], id = _b[1];
        buffer.parentLinks[id] = null;
        buffer.childLinks[id] = null;
        buffer.states[id] = null;
        buffer.instances[id] = null;
    },
    perform: function (root, _a) {
        var _b = __read(_a, 2), _code = _b[0], id = _b[1];
        delete root.parentLinks[id];
        delete root.childLinks[id];
        delete root.states[id];
        delete root.instances[id];
    },
};
var RestoreHandler = {
    fingerprint: function (moop) {
        return moop.slice(0, 2).join('/');
    },
    entities: function (moop) {
        return [moop[1]];
    },
    validate: function (model, _a) {
        var _b, _c, _d, _e;
        var _f = __read(_a, 5), code = _f[0], id = _f[1], variant = _f[2], type = _f[3], _state = _f[4];
        return ((_e = (_d = (_c = (_b = assertString(code, 'id', id)) !== null && _b !== void 0 ? _b : assertString(code, 'variant', variant)) !== null && _c !== void 0 ? _c : assertString(code, 'type', type)) !== null && _d !== void 0 ? _d : assertNotExists(model, code, id)) !== null && _e !== void 0 ? _e : pass());
    },
    reverse: function (_model, _a) {
        var _b = __read(_a, 5), _code = _b[0], id = _b[1], _variant = _b[2], _type = _b[3], _state = _b[4];
        return [$xdelete, id];
    },
    stage: function (buffer, moop) {
        this.perform(buffer, moop);
    },
    perform: function (root, _a) {
        var _b = __read(_a, 5), _code = _b[0], id = _b[1], variant = _b[2], type = _b[3], state = _b[4];
        root.instances[id] = { variant: variant, type: type };
        root.states[id] = Object.assign(registerAlloc(), state);
        if (variant === 'component') {
            root.childLinks[id] = registerAlloc();
        }
    },
};
var ComponentSetHandler = {
    fingerprint: function (moop) {
        var parts = moop.slice(0, 2);
        for (var i = 2; i < moop.length; i += 2) {
            parts.push(moop[i]);
        }
        return parts.join('/');
    },
    entities: function (moop) {
        return [moop[1]];
    },
    validate: function (model, _a) {
        var _b, _c;
        var _d = __read(_a), code = _d[0], id = _d[1], kvs = _d.slice(2);
        return ((_c = (_b = skipIfNot(assertExistsWithType(model, code, 'component', id))) !== null && _b !== void 0 ? _b : assertKeyValues(code, kvs)) !== null && _c !== void 0 ? _c : pass());
    },
    reverse: function (model, _a) {
        var _b = __read(_a), _code = _b[0], id = _b[1], kvs = _b.slice(2);
        return __spreadArray([$cset, id], __read(kvs.map(function (_, i) { var _a; return i % 2 === 0 ? kvs[i] : (_a = model.getStateValue(id, kvs[i - 1])) !== null && _a !== void 0 ? _a : null; })), false);
    },
    stage: function (buffer, _a) {
        var _b = __read(_a), _code = _b[0], id = _b[1], kvs = _b.slice(2);
        for (var i = 0; i < kvs.length; i += 2) {
            registerSet(buffer.states, id, kvs[i], kvs[i + 1], true);
        }
    },
    perform: function (root, _a) {
        var _b = __read(_a), _code = _b[0], id = _b[1], kvs = _b.slice(2);
        for (var i = 0; i < kvs.length; i += 2) {
            if (kvs[i + 1] !== null) {
                registerSet(root.states, id, kvs[i], kvs[i + 1], false);
            }
            else {
                registerDelete(root.states, id, kvs[i]);
            }
        }
    },
};
var ComponentAppendHandler = {
    fingerprint: function (moop) {
        return moop.slice(0, 3).join('/');
    },
    entities: function (moop) {
        return [moop[1], moop[2]];
    },
    validate: function (model, _a) {
        var _b, _c, _d, _e, _f, _g;
        var _h = __read(_a, 4), code = _h[0], id = _h[1], subject = _h[2], weight = _h[3];
        return ((_g = (_f = (_e = (_d = (_c = (_b = assertString(code, 'id', id)) !== null && _b !== void 0 ? _b : assertString(code, 'subject', subject)) !== null && _c !== void 0 ? _c : assertString(code, 'weight', weight)) !== null && _d !== void 0 ? _d : assertNotSameComponent(code, id, subject)) !== null && _e !== void 0 ? _e : skipIfNot(assertExistsWithType(model, code, 'component', id))) !== null && _f !== void 0 ? _f : skipIfNot(assertExistsWithType(model, code, 'component', subject))) !== null && _g !== void 0 ? _g : pass());
    },
    reverse: function (model, _a) {
        var _b = __read(_a, 3), _code = _b[0], id = _b[1], subject = _b[2];
        return [$ctruncate, id, subject];
    },
    stage: function (buffer, _a) {
        var _b = __read(_a, 4), _code = _b[0], id = _b[1], subject = _b[2], weight = _b[3];
        var prev = buffer.parentLinks[subject];
        if (prev) {
            registerDelete(buffer.childLinks, prev, subject);
        }
        buffer.parentLinks[subject] = id;
        registerSet(buffer.childLinks, id, subject, weight, true);
    },
    perform: function (root, _a) {
        var _b = __read(_a, 4), _code = _b[0], id = _b[1], subject = _b[2], weight = _b[3];
        var prev = root.parentLinks[subject];
        if (prev) {
            registerDelete(root.childLinks, prev, subject);
        }
        root.parentLinks[subject] = id;
        root.childLinks[id][subject] = weight;
        registerSet(root.childLinks, id, subject, weight, false);
    },
};
var ComponentTruncateHandler = {
    fingerprint: function (moop) {
        return moop.join('/');
    },
    entities: function (moop) {
        return [moop[1], moop[2]];
    },
    validate: function (model, _a) {
        var _b, _c, _d, _e, _f, _g;
        var _h = __read(_a, 3), code = _h[0], id = _h[1], subject = _h[2];
        return ((_g = (_f = (_e = (_d = (_c = (_b = assertString(code, 'id', id)) !== null && _b !== void 0 ? _b : assertString(code, 'subject', subject)) !== null && _c !== void 0 ? _c : assertNotSameComponent(code, id, subject)) !== null && _d !== void 0 ? _d : skipIfNot(assertExistsWithType(model, code, 'component', id))) !== null && _e !== void 0 ? _e : skipIfNot(assertExistsWithType(model, code, 'component', subject))) !== null && _f !== void 0 ? _f : skipIfNot(assertIsParent(model, code, id, subject))) !== null && _g !== void 0 ? _g : pass());
    },
    reverse: function (model, _a) {
        var _b = __read(_a, 3), _code = _b[0], id = _b[1], subject = _b[2];
        return [$cappend, id, subject, model.getChildren(id)[subject]];
    },
    stage: function (buffer, _a) {
        var _b = __read(_a, 3), _code = _b[0], id = _b[1], subject = _b[2];
        buffer.parentLinks[subject] = null;
        registerSet(buffer.childLinks, id, subject, null, true);
    },
    perform: function (root, _a) {
        var _b = __read(_a, 3), _code = _b[0], id = _b[1], subject = _b[2];
        delete root.parentLinks[subject];
        delete root.childLinks[id][subject];
        registerDelete(root.childLinks, id, subject);
    },
};
var handlers = (_a = {},
    _a[$xnoop] = NoopHandler,
    _a[$xcreate] = CreateHandler,
    _a[$xdelete] = DeleteHandler,
    _a[$xrestore] = RestoreHandler,
    _a[$cappend] = ComponentAppendHandler,
    _a[$cset] = ComponentSetHandler,
    _a[$ctruncate] = ComponentTruncateHandler,
    _a);
var pass = function () { return [$pass]; };
var skipIfNot = function (assertResult) {
    return (assertResult && assertResult[0] === $fail)
        ? [$skip, assertResult[1]]
        : assertResult;
};
// Returning null from assert enables us to use the ?? operator to fall through to subsequent assertions nicely
var assert = function (expr, message) {
    return expr ? null : [$fail, message];
};
// const assertIsDefAndNotNull = (value: any, message: string) => {
//     return (value === null || value === undefined) ? fail(message) : pass;
// };
var assertString = function (caller, name, value) {
    return assert(!!value && typeof value === 'string', "".concat((0, exports.nameFor)(caller), " failure: ").concat(name, " is invalid"));
};
var assertPrimitiveOrNull = function (caller, value) {
    var e_2, _a;
    var _b;
    if (value === null)
        return null;
    if (Array.isArray(value)) {
        try {
            for (var value_1 = __values(value), value_1_1 = value_1.next(); !value_1_1.done; value_1_1 = value_1.next()) {
                var v = value_1_1.value;
                // eslint-disable-next-line @typescript-eslint/no-unnecessary-type-assertion
                var r = assertPrimitiveOrNull(caller, v);
                if (r)
                    return r;
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (value_1_1 && !value_1_1.done && (_a = value_1.return)) _a.call(value_1);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return null;
    }
    return ((_b = assert(typeof (value) === 'string' || typeof (value) === 'number' || typeof (value) === 'boolean', "".concat((0, exports.nameFor)(caller), " failure: ").concat(value, " is not a primitive."))) !== null && _b !== void 0 ? _b : assert(typeof (value) !== 'number' || isFinite(value), "".concat((0, exports.nameFor)(caller), " failure: ").concat(value, " is not an accepted number value.")));
};
var assertKey = function (caller, value) {
    var _a;
    return (_a = assertString(caller, 'key', value)) !== null && _a !== void 0 ? _a : assert(value.length >= 1 && value.length <= 128 && !!/[A-Za-z\$\_]([A-Za-z0-9\.\_\$]*)/.exec(value) && !value.includes('..'), "".concat((0, exports.nameFor)(caller), " failure: ").concat(value, " is not valid key."));
};
var assertKeyValues = function (caller, input) {
    var _a, _b;
    return (_b = (_a = assert(input.length > 0, "".concat((0, exports.nameFor)(caller), " failure: key value sequence empty."))) !== null && _a !== void 0 ? _a : assert(input.length % 2 === 0, "".concat((0, exports.nameFor)(caller), " failure: key value sequence odd length."))) !== null && _b !== void 0 ? _b : input.reduce(function (t, x, i) { return (t !== null && t !== void 0 ? t : (i % 2 === 0)) ? assertKey(caller, x) : assertPrimitiveOrNull(caller, x); }, null);
};
var assertNotExists = function (model, caller, id) {
    return assert(!model.exists(id), "".concat((0, exports.nameFor)(caller), " failure: ").concat(id, " already exists."));
};
var assertExists = function (model, caller, id) {
    return assert(model.exists(id), "".concat((0, exports.nameFor)(caller), " failure: ").concat(id, " does not exist."));
};
var assertExistsWithType = function (model, caller, variant, typeOrId, id) {
    var _a;
    var type = !id ? null : typeOrId;
    id = !id ? typeOrId : id;
    var ae = assertExists(model, caller, id);
    if (ae)
        return ae;
    var info = model.getInfo(id);
    return ((_a = assert(info.variant === variant, "".concat((0, exports.nameFor)(caller), " failure: ").concat(id, " is not a ").concat(variant, "."))) !== null && _a !== void 0 ? _a : assert(type === null || info.type === type, "".concat((0, exports.nameFor)(caller), " failure: ").concat(id, " is not a ").concat(type, ".")));
};
var assertNotSameComponent = function (caller, id1, id2) {
    return assert(id1 !== id2, "".concat((0, exports.nameFor)(caller), " failure: Both components are the same."));
};
var assertNoParent = function (model, caller, id) {
    return assert(!model.getParent(id), "".concat((0, exports.nameFor)(caller), " failure: ").concat(id, " is not an orphan."));
};
var assertNoChildren = function (model, caller, id) {
    var _a;
    return assert(!Object.keys((_a = model === null || model === void 0 ? void 0 : model.getChildren(id)) !== null && _a !== void 0 ? _a : {}).find(function (x) { return x !== '__v'; }), "".concat((0, exports.nameFor)(caller), " failure: ").concat(id, " is not without children."));
};
var assertIsParent = function (model, caller, id, subject) {
    return assert(model.getParent(subject) === id, "".concat((0, exports.nameFor)(caller), " failure: ").concat(subject, " is not a child of ").concat(id, "."));
};
var registerAlloc = ModelTypes_1.ModelRegister.create;
var registerSet = function (registers, id, key, value, autoAlloc) {
    if (!registers[id]) {
        if (autoAlloc)
            registers[id] = {};
        else
            throw new Error('Missing register');
    }
    var reg = registers[id];
    reg[key] = value;
    reg.__v = ModelTypes_1.ModelRegister.version();
};
var registerDelete = function (registers, id, key) {
    if (!registers[id]) {
        throw new Error('Missing register');
    }
    var reg = registers[id];
    delete reg[key];
    reg.__v = ModelTypes_1.ModelRegister.version();
};
